import React from 'react';

export default function Logo(props) {
    return <svg viewBox="0 0 148 144" {...props}>
        <path d="M101.368 59.316l35.915 9.61-17.967 66.96c-1.438 5.329-6.918 8.493-12.252 7.073l-26.255-7.025 20.559-76.618zM9.623 78.448l76.728 20.53-9.623 35.864L0 114.312l9.623-35.864zM40.936.34l26.255 7.025-20.559 76.619-35.915-9.61 17.967-66.96c1.438-5.33 6.918-8.493 12.252-7.074zm30.336 8.117L148 28.986l-9.623 35.864-76.728-20.53 9.623-35.864z" fill="currentColor"/>
    </svg>;
}